import { useAtomValue } from "jotai";
import { type FunctionComponent, useMemo } from "react";
import { graphql, readInlineData } from "react-relay";

import { checkIsStyleArticle } from "scmp-app/components/article/article-render/style-article/helper";
import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { currentArticleAtom } from "scmp-app/lib/current-item";
import type { bookmarkHeaderFeaturesContent$key } from "scmp-app/queries/__generated__/bookmarkHeaderFeaturesContent.graphql";

import { Container, StyledContentBookmark } from "./styles";

export type HeaderFeaturesBookmarkProps = HeaderFeatureCommonProps;

export type Variant = "default" | "magazines-style";

export const HeaderFeaturesBookmark: FunctionComponent<HeaderFeaturesBookmarkProps> = ({
  ...props
}) => {
  const currentArticle = useAtomValue(currentArticleAtom);

  const variant: Variant = useMemo(() => {
    if (currentArticle && checkIsStyleArticle(currentArticle)) {
      return "magazines-style";
    }
    return "default";
  }, [currentArticle]);

  if (!currentArticle) return null;

  const data = readInlineData<bookmarkHeaderFeaturesContent$key>(
    graphql`
      fragment bookmarkHeaderFeaturesContent on Content @inline {
        entityId
      }
    `,
    currentArticle,
  );

  const { entityId } = data;

  return (
    <Container {...getResponsiveProps(props)}>
      <StyledContentBookmark
        $variant={variant}
        entityId={entityId}
        ga4Events={{
          click: {
            action: "click",
            category: "bookmark",
            customized_parameters: {
              action_type: "add",
              article_id: entityId,
              trigger_point: "masthead",
            },
            subcategory: "",
          },
        }}
      />
    </Container>
  );
};

HeaderFeaturesBookmark.displayName = "HeaderFeaturesBookmark";
